import { BuyerWallet } from "src/app/models";
import { makeBusinessEntity, PartialBusinessEntityOptions } from "../../../lib/libby/generator";
import { businessOptions } from "../businessOptions";

const DAO_NAME = "buyer_wallet";

const defaultOptions: PartialBusinessEntityOptions<any> = {
  hoc: {
    withAccordionSelector: {
      idKey: "buyer_wallet_id",
      labelKey: "wallet",
    },
    withSelectedChips: {
      idKey: "buyer_wallet_id",
      labelKey: "wallet",
    },
  },
};

const optionsToUse = !businessOptions.BuyerWallet
  ? defaultOptions
  : {
      ...defaultOptions,
      ...businessOptions.BuyerWallet,
      hoc: { ...defaultOptions.hoc, ...businessOptions.BuyerWallet.hoc },
    };

const {
  hook: { fetchById, libbyCall, libbyDAO, libbyFetch },
  hoc: { entityAutocomplete, renderPropCall, renderPropFetchById, simpleSelect, accordionSelector, selectedChips },
  context: {
    byIdContext: { useByIdContext, ByIdProvider, ByIdContext },
  },
} = makeBusinessEntity<BuyerWallet>(DAO_NAME, optionsToUse);

// hooks
export const useBuyerWalletFetchById = fetchById;
export const useBuyerWalletLibbyCall = libbyCall;
export const useBuyerWalletDAO = libbyDAO;
export const useBuyerWalletLibbyFetch = libbyFetch;

// components/hoc
export const BuyerWalletAutocomplete = entityAutocomplete;
export const BuyerWalletCall = renderPropCall;
export const BuyerWalletById = renderPropFetchById;
export const BuyerWalletSelect = simpleSelect;
export const BuyerWalletAccordionSelector = accordionSelector;
export const BuyerWalletSelectedChips = selectedChips;

// context
// ByIdContext
export const useBuyerWalletByIdContext = useByIdContext;
export const BuyerWalletByIdProvider = ByIdProvider;
export const BuyerWalletByIdContext = ByIdContext;
// GeneralContext
// export const usePaymentContext = useGeneralContext;
// export const PaymentProvider = GeneralProvider;
// export const PaymentContext = GeneralContext; // Para esta entidad usaremos un contexto personalizado
